'use client';

import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@pc/components/ui/table';
import { useState } from 'react';

function RelatedOrganizationsTable() {
  const [open, setOpen] = useState(false);
  return (
    <div>
      <button className='mb-8 font-medium text-[#0459c1]' onClick={() => setOpen(!open)}>
        {'불법촬영물 등 신고 삭제 요청 기관 단체'}
      </button>
      {open && (
        <Table className='w-[1010px] text-[16px]'>
          <colgroup>
            <col width='225px' />
            <col width='*' />
          </colgroup>
          <TableHeader>
            <TableRow className='h-12 text-baseFg'>
              <TableHead className='font-[700] text-[15px]'>{'소재지'}</TableHead>
              <TableHead className='font-[700] text-[15px]'>{'기관 단체명'}</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            <TableRow className='h-auto text-baseFg'>
              <TableCell rowSpan={2} className='text-base'>
                서울
              </TableCell>
              <TableCell className='border-borderBg11 border-l-[1px] px-3.5 py-2.5 text-left text-base'>
                서울시여성가족재단 <br />
                (서울디지털성범죄안심지원센터)
              </TableCell>
            </TableRow>
            <TableRow className='h-auto text-baseFg'>
              <TableCell className='border-borderBg11 border-l-[1px] px-3.5 py-2.5 text-left text-base'>
                십대여성인권센터
              </TableCell>
            </TableRow>
            <TableRow className='h-auto text-baseFg'>
              <TableCell className='px-3.5 py-2.5 text-base'>부산</TableCell>
              <TableCell className='border-borderBg11 border-l-[1px] px-3.5 py-2.5 text-left text-base'>
                부산광역시 여성폭력방지종합지원센터 ( 이젠센터 )
              </TableCell>
            </TableRow>
            <TableRow className='h-auto text-baseFg'>
              <TableCell className='px-3.5 py-2.5 text-base'>대구</TableCell>
              <TableCell className='border-borderBg11 border-l-[1px] px-3.5 py-2.5 text-left text-base'>
                ( 사 ) 대구여성의전화 부설 여성인권상담소 피어라
              </TableCell>
            </TableRow>
            <TableRow className='h-auto text-baseFg'>
              <TableCell className='px-3.5 py-2.5 text-base'>인천</TableCell>
              <TableCell className='border-borderBg11 border-l-[1px] px-3.5 py-2.5 text-left text-base'>
                인천여성가족재단 <br />( 인천 디지털성범죄 예방대응센터 )
              </TableCell>
            </TableRow>
            <TableRow className='h-auto text-baseFg'>
              <TableCell className='px-3.5 py-2.5 text-base'>광주</TableCell>
              <TableCell className='border-borderBg11 border-l-[1px] px-3.5 py-2.5 text-left text-base'>
                ( 사 ) 광주여성민우회 디지털성범죄특화상담소
              </TableCell>
            </TableRow>
            <TableRow className='h-auto text-baseFg'>
              <TableCell className='px-3.5 py-2.5 text-base'>대전</TableCell>
              <TableCell className='border-borderBg11 border-l-[1px] px-3.5 py-2.5 text-left text-base'>
                ( 사 ) 대전여민회 부설 성폭력상담소 다힘
              </TableCell>
            </TableRow>
            <TableRow className='h-auto text-baseFg'>
              <TableCell className='px-3.5 py-2.5 text-base'>울산</TableCell>
              <TableCell className='border-borderBg11 border-l-[1px] px-3.5 py-2.5 text-left text-base'>
                동구 가정성폭력통합상담소
              </TableCell>
            </TableRow>
            <TableRow className='h-auto text-baseFg'>
              <TableCell className='px-3.5 py-2.5 text-base'>세종</TableCell>
              <TableCell className='border-borderBg11 border-l-[1px] px-3.5 py-2.5 text-left text-base'>
                ( 사 ) 세종 YWCA 성인권상담센터
              </TableCell>
            </TableRow>
            <TableRow className='h-auto text-baseFg'>
              <TableCell className='px-3.5 py-2.5 text-base'>경기</TableCell>
              <TableCell className='border-borderBg11 border-l-[1px] px-3.5 py-2.5 text-left text-base'>
                경기도여성가족재단 <br /> ( 경기도 디지털성범죄피해자 원스톱 지원센터)
              </TableCell>
            </TableRow>
            <TableRow className='h-auto text-baseFg'>
              <TableCell className='px-3.5 py-2.5 text-base'>충남</TableCell>
              <TableCell className='border-borderBg11 border-l-[1px] px-3.5 py-2.5 text-left text-base'>
                여성긴급전화 1366 충남센터
              </TableCell>
            </TableRow>
            <TableRow className='h-auto text-baseFg'>
              <TableCell className='px-3.5 py-2.5 text-base'>충북</TableCell>
              <TableCell className='border-borderBg11 border-l-[1px] px-3.5 py-2.5 text-left text-base'>
                ( 사 ) 충북여성인권 부설 상담소 늘봄
              </TableCell>
            </TableRow>
            <TableRow className='h-auto text-baseFg'>
              <TableCell className='px-3.5 py-2.5 text-base'>전남</TableCell>
              <TableCell className='border-borderBg11 border-l-[1px] px-3.5 py-2.5 text-left text-base'>
                여성긴급전화 1366 전남센터
              </TableCell>
            </TableRow>
            <TableRow className='h-auto text-baseFg'>
              <TableCell className='px-3.5 py-2.5 text-base'>전북</TableCell>
              <TableCell className='border-borderBg11 border-l-[1px] px-3.5 py-2.5 text-left text-base'>
                ( 사 ) 성폭력예방치료센터 부설 전주성폭력상담소
              </TableCell>
            </TableRow>
            <TableRow className='h-auto text-baseFg'>
              <TableCell className='px-3.5 py-2.5 text-base'>경북</TableCell>
              <TableCell className='border-borderBg11 border-l-[1px] px-3.5 py-2.5 text-left text-base'>
                여성긴급전화 1366 경북센터
              </TableCell>
            </TableRow>
            <TableRow className='h-auto text-baseFg'>
              <TableCell className='px-3.5 py-2.5 text-base'>경남</TableCell>
              <TableCell className='border-borderBg11 border-l-[1px] px-3.5 py-2.5 text-left text-base'>
                여성긴급전화 1366 경남센터
              </TableCell>
            </TableRow>
            <TableRow className='h-auto text-baseFg'>
              <TableCell className='px-3.5 py-2.5 text-base'>제주</TableCell>
              <TableCell className='border-borderBg11 border-l-[1px] px-3.5 py-2.5 text-left text-base'>
                제주 YWCA 디지털성범죄상담소
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      )}
    </div>
  );
}

export default RelatedOrganizationsTable;
